import API from './api';
import { fetchData } from './fetch';

export function getCircleEntrySetting() {
    return fetchData(API.GET_CIRCLE_ENTRY_ACCESS.url, API.GET_CIRCLE_ENTRY_ACCESS.type, {});
}
